import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// @ts-ignore
import { Slider } from "react-burgers";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import logo from "./images/avaya-onecloud-top-logo.svg";
import mobileLogo from "./images/avaya-mobile-logo.svg";
import footerLogo from "./images/avaya-footer-logo.svg";
import "./Layout.scss";
import { t } from "i18next";

export const TAB_LOOKUP = {
  INNOVATE_YOUR_WAY: 0,
  ON_PREM_TO_CLOUD: 1,
  ALL_CLOUD: 2,
  SUPPORT_SERVICES: 3,
  NO_DEV_NEEDED: 4,
  WHY_AVAYA: 5,
};

function Layout({
  activeTab = 0,
  children,
}: {
  activeTab?: number;
  children: any;
}) {
  const sliderRef = React.useRef<Slider | null>(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  switch (pathname) {
    case "/":
      activeTab = TAB_LOOKUP.INNOVATE_YOUR_WAY;
      break;
    case "/global-leader":
      activeTab = TAB_LOOKUP.INNOVATE_YOUR_WAY;
      break;
    case "/innovation-evolution":
      activeTab = TAB_LOOKUP.INNOVATE_YOUR_WAY;
      break;
    case "/add-innovation":
      activeTab = TAB_LOOKUP.INNOVATE_YOUR_WAY;
      break;
    case "/on-prem-to-cloud":
      activeTab = TAB_LOOKUP.ON_PREM_TO_CLOUD;
      break;
    case "/deeper-relationships":
      activeTab = TAB_LOOKUP.ON_PREM_TO_CLOUD;
      break;
    case "/elite-customers":
      activeTab = TAB_LOOKUP.ON_PREM_TO_CLOUD;
      break;
    case "/all-cloud":
      activeTab = TAB_LOOKUP.ALL_CLOUD;
      break;
    case "/dedicated-cloud":
      activeTab = TAB_LOOKUP.ALL_CLOUD;
      break;
    case "/support-services":
      activeTab = TAB_LOOKUP.SUPPORT_SERVICES;
      break;
    case "/global-support-services":
      activeTab = TAB_LOOKUP.SUPPORT_SERVICES;
      break;
    case "/no-dev-needed":
      activeTab = TAB_LOOKUP.NO_DEV_NEEDED;
      break;
    case "/why-avaya":
      activeTab = TAB_LOOKUP.WHY_AVAYA;
      break;
    case "/ready":
      activeTab = TAB_LOOKUP.WHY_AVAYA;
      break;

    default:
      activeTab = 0;
      break;
  }

  let tabStatus = [];
  for (let i = 0; i <= 6; i++) {
    tabStatus[i] =
      activeTab === i
        ? "navbar-active-tab"
        : activeTab > i
        ? "navbar-bold-tab"
        : "navbar-inactive-tab";
  }

  const SampleNextArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: currentSlide < 3 ? "block" : "none",
        }}
        onClick={onClick}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: currentSlide === 0 ? "none" : "block",
        }}
        onClick={onClick}
      />
    );
  };

  const settings = {
    // dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 6,
    activeSlide: 0,
    afterChange: (index: number) => {
      console.log("afterChange: index", index);
      setCurrentSlide(index);
    },
    beforeChange: (current: number, next: number) => {
      console.log("beforeChange: current", current);
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1050, // make sure this matches the menu break point
        settings: {
          className: "center",
          centerMode: true,
          // infinite: true,
          centerPadding: "60px",
          slidesToShow: 1,
          // speed: 500
        },
      },
    ],
  };

  useEffect(() => {
    if (menuOpen) setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={`main-container ${pathname.split("/").pop()}`}>
      <div className="navbar-container-mobile">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <a href="https://www.avaya.com">
            <img src={mobileLogo} style={{ marginTop: 18 }} alt="avaya logo" />
          </a>
          <div className="flex" />
          <Slider
            width={30}
            active={menuOpen}
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          />
        </div>
      </div>
      <div className="navbar-container drop-shadow">
        <div className={`container ${menuOpen ? "open" : ""}`}>
          <a href="https://www.avaya.com">
            <img src={logo} alt="avaya logo" />
          </a>
          <div className="navbar-space" />
          <div
            className={`navbar-item ${
              tabStatus[TAB_LOOKUP.INNOVATE_YOUR_WAY]
            } margin-right-40`}
          >
            <Link to="/">{t("navbar.innovate")}</Link>
          </div>
          <div
            className={`navbar-item ${
              tabStatus[TAB_LOOKUP.ON_PREM_TO_CLOUD]
            } margin-right-40`}
          >
            <Link to="/on-prem-to-cloud">{t("navbar.on-prem-to-cloud")}</Link>
          </div>
          <div
            className={`navbar-item ${
              tabStatus[TAB_LOOKUP.ALL_CLOUD]
            } margin-right-40`}
          >
            <Link to="/all-cloud">{t("navbar.all-cloud")}</Link>
          </div>
          <div
            className={`navbar-item ${
              tabStatus[TAB_LOOKUP.SUPPORT_SERVICES]
            } margin-right-40`}
          >
            <Link to="/support-services">{t("navbar.support")}</Link>
          </div>
          <div
            className={`navbar-item ${
              tabStatus[TAB_LOOKUP.NO_DEV_NEEDED]
            } margin-right-40`}
          >
            <Link to="/no-dev-needed">{t("navbar.no-dev")}</Link>
          </div>
          <div className={`navbar-item ${tabStatus[TAB_LOOKUP.WHY_AVAYA]}`}>
            <Link to="/why-avaya">{t("navbar.why-avaya")}</Link>
          </div>
        </div>
      </div>

      <div className="content">{children}</div>
      <div className="footer">
        <div className="container">
          <img src={footerLogo} alt="avaya logo" />
          <div style={{ flex: 1 }}></div>
          <div>© 2023 Avaya LLC</div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
